import React, { useEffect, useState } from "react";
import { PageHero } from "../components/Section";
import ProductCard from "../components/ProductCard";
import { useApp } from "../context/AppContext";
import { useReveal } from "../hooks/useReveal";
import { products as mockProducts, IMAGES } from "../data/mock";
import { getProducts } from "../services/api";
import Seo from "../components/Seo";

const Store = () => {
  const { t, lang } = useApp();
  const [cat, setCat] = useState("all");
  const [type, setType] = useState("all");
  const [products, setProducts] = useState(mockProducts);
  useReveal([cat, type, products]);

  useEffect(() => {
    getProducts().then((d) => { if (Array.isArray(d) && d.length) setProducts(d); }).catch(() => {});
  }, []);

  const filtered = products.filter((p) =>
    (cat === "all" || p.category === cat) && (type === "all" || p.type === type)
  );

  const cats = [
    { id: "all", label: t("store.all") },
    { id: "single", label: t("store.single") },
    { id: "starter", label: t("store.starter") },
  ];
  const types = [
    { id: "all", label: t("store.all") },
    { id: "red", label: t("store.red") },
    { id: "white", label: t("store.white") },
  ];

  return (
    <div className="pt-20 bg-cream min-h-screen">
      <Seo title={t("store.title")} description={t("store.sub")} image={IMAGES.bottles4} path="/store" lang={lang} jsonLd={{ "@context": "https://schema.org", "@type": "ItemList", itemListElement: products.map((p, i) => ({ "@type": "ListItem", position: i + 1, url: `https://myowncuvee.com/product/${p.id}`, name: (lang === "de" && p.name_de) || p.name })) }} />
      <PageHero title={t("store.title")} subtitle={t("store.sub")} image={IMAGES.bottles4} />
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {cats.map((c) => (
            <button key={c.id} onClick={() => setCat(c.id)} className={`px-5 py-2 rounded-full text-sm font-medium border transition-all ${cat === c.id ? "bg-wine text-white border-wine" : "bg-white text-ink/70 border-border hover:border-wine"}`}>{c.label}</button>
          ))}
          <span className="w-px bg-border mx-2 hidden sm:block" />
          {types.map((c) => (
            <button key={c.id} onClick={() => setType(c.id)} className={`px-5 py-2 rounded-full text-sm font-medium border transition-all ${type === c.id ? "bg-gold text-ink border-gold" : "bg-white text-ink/70 border-border hover:border-gold"}`}>{c.label}</button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7">
          {filtered.map((p) => <div key={p.id} className="reveal"><ProductCard product={p} /></div>)}
        </div>
      </div>
    </div>
  );
};

export default Store;
